<template>
	<HeroConstructor
		bg="/static/img/job_openings/hero-bg-careers.jpg"
		title="JOB<br/>OPENINGS"
		theme="blue"
	>
		<p class="paragraph paragraph--xl">
			We’re always on the lookout for talented people to join our team.
			Whether your expertise is in programming, art, design, animation,
			testing, publishing, or something else — we all share one common
			goal: to create rich gaming experiences based on various topics of
			fascination.
		</p>
		<div style="display: flex; flex-direction: column; gap: 10px;">
			<BasicButton
				class="content__link"
				type="black"
				style="width: fit-content;"
				v-scroll-to="{ element: '#jobs', duration: 1000 }"
				>View Open Positions</BasicButton
			>
			<basic-button
				class=""
				style="width: fit-content;"
				type="black"
				tag="router-link"
				to="/subscribe"
				>Get Notifications for New Job Openings ->
			</basic-button>
		</div>
	</HeroConstructor>
</template>

<script>
import HeroConstructor from "../common/HerroConstructor";
import BasicButton from "../BasicButton";

export default {
	name: "hero",
	components: {
		HeroConstructor,
		BasicButton
	}
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../../assets/scss/globals";
@import "../../assets/scss/mixins";

.section-positions-hero {
	background: url("/static/img/open_application/job-openings.png") no-repeat
		center;
	background-size: cover;
}

.content-wrapper {
	min-height: 100vh;
	display: flex;
	align-items: center;

	@media (max-width: $mq-xs-max) {
		align-items: flex-end;
		min-height: auto;
	}
}

.content {
	font-size: 1rem;
	padding: em(75) em(110) em(71) em(98);
	max-width: 720px;

	.heading {
		color: $text-strong;
		line-height: 1.23;
	}

	.paragraph {
		font-size: 18px;
		margin-top: 10px;
		line-height: 1.75;
	}

	&__link {
		margin-top: 90px;
	}

	@media (max-width: $mq-lg-max) {
		font-size: 0.7rem;
		width: 600px;

		.heading {
			font-size: 60px;
		}

		&__link {
			margin-top: 40px;
			font-size: 15px !important;
		}
	}

	@media (max-width: $mq-md-max) {
		width: 70%;

		.paragraph {
			font-size: 16px;
		}
	}

	@media (max-width: $mq-xs-max) {
		width: auto;
		max-width: none;
		height: 100%;
		margin: 0 -20px;
		padding: 40px 20px;
	}

	@media (max-width: $mq-xs) {
		.heading {
			font-size: 42px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/openPositions/Hero.vue